import CloseIcon from "@mui/icons-material/Close";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import {
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";

import { EQUIPMENT_VALUE_TO_LABEL_MAP } from "constants/index";

interface Props {
  modalOpen: boolean;
  onModalClose: VoidFunction;
  equipmentTypes: string[];
}

export function CarrierInformationEquipmentsModal(props: Props) {
  const { modalOpen, onModalClose, equipmentTypes } = props;

  return (
    <Dialog open={modalOpen} onClose={onModalClose}>
      <DialogTitle component="div">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HomeRepairServiceOutlinedIcon color="primary" fontSize="medium" />
          <Typography variant="h5">Equipment Type</Typography>
          <Tooltip title="Close the full list of equipment types">
            <IconButton
              aria-label="Close equipment types"
              onClick={onModalClose}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {equipmentTypes.map((type) => (
            <Chip
              label={EQUIPMENT_VALUE_TO_LABEL_MAP[type]}
              color="primary"
              variant="outlined"
              key={type}
            />
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
